import React from "react";
import { Button, Tooltip } from "@mantine/core";
import { appStore } from "@/app/store/appStore";
import { getRedirect, openLink, rememberLocationForPostOauth } from "@shared/utils/helpers";
import { IconBrandFacebook } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { persistStore } from "@entities/StepFolder/store/persistStore";

const FacebookOAuthButton: React.FC = () => {
	const { t } = useTranslation();
	const isPrivacy = persistStore(state => state.isPrivacy);

	const appId = appStore.getState().gameConfig.PublicWebClientConfig.Auth?.Facebook?.AppId;

	const initiateLogin = () => {
		const authUrl = `https://www.facebook.com/v20.0/dialog/oauth?client_id=${appId}&redirect_uri=${getRedirect("facebook")}&response_type=token&scope=email,public_profile`;
		rememberLocationForPostOauth();
		openLink(authUrl);
	};

	return (
		appId && (
			<Button disabled={!isPrivacy} variant={"box"} onClick={initiateLogin}>
				<Tooltip label={t("common.LoginWithFacebook", "Login with Facebook")}>
					<IconBrandFacebook />
				</Tooltip>
			</Button>
		)
	);
};

export default FacebookOAuthButton;
